import moment from "moment";
import apis from "../../../api";
import { errorTypes } from "../../../utils/errorTypes";
import { mode } from "../../../utils/formModes";
import { myModerations } from "../../../utils/mainTabs/social/myModerations";
import { pollManagement } from "../../../utils/mainTabs/social/pollManagement";
import { submisssions } from "../../../utils/mainTabs/social/submissions";
import loaders from "../actionCreators/loadersActionCreator";
import { getClassDetailsByIdAction } from "../actionCreators/manageActionCreator";
import {
  copyPollResponse,
  distributePollResponse,
  editPollResponse,
  setCreateForumThreadResponse,
  setCreateForumTopicResponse,
  setEditForumTopicResponse,
  setForumThreads,
  setForumTopics,
  setPollUserGroup,
  setTenantPollUsers,
} from "../actionCreators/socialActionCreator";
import { setErrorHandler } from "./errorActionHandler";
import {
  getStoredMediaInfoActionHandler,
  setMetaDataForVideoActionHandler,
  uploadPdfShotClassActionHandler,
  uploadPptShotClassActionHandler,
  uploadScormOrHtmlShotClassActionHandler,
  uploadSlideShareActionHandler,
  uploadVideoChunkActionHandler,
} from "./manageActionHandler";
import { downloadFile } from "../../../utils/downloadFile";

/** POLL MANAGEMENT API HANDLER STARTS **/
export const getAllPollsHandler =
  (setAllPollData, setDefaultAllPollData, setTotalRows, setPollLoader) =>
  async () => {
    setPollLoader(true);
    await apis.social
      .getAllPolls()
      .then((allPollsResponse) => {
        apis.social.getMyPolls().then((myPollsResponse) => {
          setPollLoader(false);
          setAllPollData([
            ...myPollsResponse.data.sort(
              (a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn),
            ),
            ...allPollsResponse.data.sort(
              (a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn),
            ),
          ]);
          setDefaultAllPollData([
            ...myPollsResponse.data.sort(
              (a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn),
            ),
            ...allPollsResponse.data.sort(
              (a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn),
            ),
          ]);
          setTotalRows(
            myPollsResponse.data.length + allPollsResponse.data.length,
          );
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
}

export const postImageHandler =
  (data, pollData, navigate, formMode, pollName, tenantName, setPollLoader) =>
  async (dispatch) => {
    let addimagetempArr = [],
      editimagetempArr = [],
      addFlag = 0,
      editFlag = 0;
    console.log("🎯 =============== INSIDE postImageHandler =================");
    console.log("📊 formMode:", formMode);
    console.log("📦 data array:", data);
    console.log("🏗️ pollData:", pollData);
    
    setPollLoader(true);
    for (let i = 0; i < data.length; i++) {
      if (data[i] && formMode === mode.ADD) {
        addFlag++;
        const formData = new FormData();
        formData.append("file", data[i]);
        apis.social
          .postImage(formData)
          .then((response) => {
            if (i === 0) {
              pollData.PollImageUrl = response.data;
              addimagetempArr.push(i);
            } else {
              const updatedPollData = pollData.OptionImageUrls;
              Object.entries(updatedPollData).forEach(([key], index) => {
                if (index + 1 === i) {
                  updatedPollData[key] = response.data;
                  addimagetempArr.push(i);
                }
              });
              pollData.OptionImageUrls = updatedPollData;
            }
            if (addimagetempArr.length === addFlag) {
              dispatch(
                postPollHandler(
                  pollData,
                  navigate,
                  pollName,
                  tenantName,
                  setPollLoader,
                ),
              );
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      // Check if data[i] is valid for processing (similar to ADD mode validation)
      const isValidForUpload = data[i] && 
        (data[i] instanceof File ||           // File object for new upload
         isValidHttpUrl(data[i]) ||           // Valid URL string for existing 
         (data[i] && data[i].length > 0));    // FileList with content
      
      if (
        isValidForUpload &&
        (formMode === mode.EDIT || formMode === mode.COPY)
      ) {
        console.log(`✅ VALID for processing - Index ${i}:`, data[i]);
        console.log(`📁 Type: ${typeof data[i]}`);
        console.log(`🌐 Is valid URL:`, isValidHttpUrl(data[i]));
        console.log(`📄 Is File:`, data[i] instanceof File);
        
        if (isValidHttpUrl(data[i])) {
          console.log(`✅ EXISTING URL - Index ${i}`);
          if (i === 0) {
            // Handle existing thumbnail URL - only set PollImageUrl
            console.log("🖼️ Setting existing thumbnail URL:", data[i]);
            pollData.PollImageUrl = data[i];
          } else {
            // Handle existing option image URLs - only set OptionImageUrls
            console.log(`🎯 Setting existing option image ${i}:`, data[i]);
            const updatedPollData = pollData.OptionImageUrls;
            Object.entries(updatedPollData).forEach(([key], index) => {
              if (index === i - 1) {
                // Adjust index for option images (i-1 because thumbnail is at i=0)
                updatedPollData[key] = data[i];
              }
            });
            pollData.OptionImageUrls = updatedPollData;
          }
        } else {
          console.log(`📤 NEW FILE UPLOAD - Index ${i}:`, data[i]);
          editFlag++;
          const formData = new FormData();
          formData.append("file", data[i][0] || data[i]);
          apis.social
            .postImage(formData)
            .then((response) => {
              console.log(`✨ postImage response for index ${i}:`, response.data);
              if (i === 0) {
                // Handle fresh thumbnail upload - only set PollImageUrl
                console.log("🆕 Setting new thumbnail URL:", response.data);
                pollData.PollImageUrl = response.data;
                editimagetempArr.push(i);
              } else {
                // Handle fresh option image uploads - only set OptionImageUrls
                console.log(`🆕 Setting new option image ${i}:`, response.data);
                const updatedPollData = pollData.OptionImageUrls;
                Object.entries(updatedPollData).forEach(([key], index) => {
                  if (index === i - 1) {
                    // Adjust index for option images (i-1 because thumbnail is at i=0)
                    updatedPollData[key] = response.data;
                    editimagetempArr.push(i);
                  }
                });
                pollData.OptionImageUrls = updatedPollData;
              }

              console.log(`📊 Progress: ${editimagetempArr.length}/${editFlag} uploads complete`);
              if (editimagetempArr.length === editFlag) {
                console.log("🚀 All uploads complete, calling edit/copy API");
                if (formMode === mode.EDIT)
                  dispatch(editPollHandler(pollData, pollName, setPollLoader));
                else
                  dispatch(
                    copyPollHandler(
                      pollData,
                      navigate,
                      pollName,
                      tenantName,
                      setPollLoader,
                    ),
                  );
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    }
    console.log(`🏁 Final editFlag: ${editFlag}`);
    if ((formMode === mode.EDIT || formMode === mode.COPY) && editFlag === 0) {
      console.log("🎯 NO NEW UPLOADS - Direct edit/copy API call");
      console.log("📋 Final pollData:", pollData);
      if (formMode === mode.EDIT) {
        console.log("📝 Calling editPollHandler directly");
        dispatch(editPollHandler(pollData, pollName, setPollLoader));
      } else {
        console.log("📄 Calling copyPollHandler directly");
        dispatch(
          copyPollHandler(
            pollData,
            navigate,
            pollName,
            tenantName,
            setPollLoader,
          ),
        );
      }
    }
  };

export const postPollHandler =
  (data, navigate, pollName, tenantName, setPollLoader) => async (dispatch) => {
    await apis.social
      .isPollExist(0, pollName)
      .then((response) => {
        if (response.data) {
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "Question already exists, it should be a unique.",
            ),
          );
        } else {
          apis.social.postPoll(data).then((response) => {
            dispatch(
              setErrorHandler(errorTypes.SUCCESS, "Poll Created Successfully"),
            );
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // dispatch(loaders.social.pollLoader(false));
        setPollLoader(false);
        navigate(pollManagement.path(tenantName));
      });
  };

export const editPollHandler =
  (data, pollName, setPollLoader) => async (dispatch) => {
    // console.log(data);
    await apis.social.isPollExist(data?.PollId, pollName).then((response) => {
      if (response.data) {
        dispatch(
          setErrorHandler(
            errorTypes.FAIL,
            "Question already exists, it should be a unique.",
          ),
        );
        setPollLoader(false);
      } else {
        apis.social
          .editPoll(data)
          .then((response) => {
            if (response.data) {
              dispatch(editPollResponse(response.data));
              dispatch(
                setErrorHandler(errorTypes.SUCCESS, "Poll Edited Successfully"),
              );
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setPollLoader(false);
            // dispatch(loaders.social.pollLoader(false));
          });
      }
    });
  };

export const getPollByIdHandler = (id, time, setData) => async () => {
  await apis.social
    .getPollById(id, time)
    .then((response) => {
      if (response.data) setData(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const isPollExistHandler =
  (id, name, setData, setIsPollNameExistLoader) => async (dispatch) => {
    // dispatch(loaders.social.pollNameExistLoadingLoader(true));
    setIsPollNameExistLoader(true);
    await apis.social
      .isPollExist(id, name)
      .then((response) => {
        if (response.data)
          setData("Question already exists, it should be a unique.");
        else setData("");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // dispatch(loaders.social.pollNameExistLoadingLoader(false));
        setIsPollNameExistLoader(false);
      });
  };

export const deletePollHandler =
  (data, handleSearchQuery, setisDeleteModalOpen, setDeletePollLoading) =>
  async (dispatch) => {
    setDeletePollLoading(true);
    dispatch(loaders.social.deletePollLader(true));
    await apis.social
      .deletePoll(data)
      .then((response) => {
        setDeletePollLoading(false);
        if (response.data > 0)
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Polls Deleted Successfully"),
          );
        else if (response.data < 0)
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "Distributed polls cannot be deleted",
            ),
          );
        else {
          dispatch(setErrorHandler(errorTypes.FAIL, "Deletion Failed"));
        }
        handleSearchQuery();
        setisDeleteModalOpen(false);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.social.deletePollLader(false));
      });
  };

export const copyPollHandler =
  (data, navigate, pollName, tenantName, setPollLoader) => async (dispatch) => {
    await apis.social
      .isPollExist(0, pollName)
      .then((response) => {
        if (response.data) {
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "Question already exists, it should be a unique.",
            ),
          );
        } else {
          apis.social.copyPoll(data).then((response) => {
            if (response.data > 0) {
              dispatch(
                setErrorHandler(errorTypes.SUCCESS, "Poll Copied Successfully"),
              );
              dispatch(copyPollResponse(response.data));
              navigate(pollManagement.path(tenantName));
            } else {
              dispatch(setErrorHandler(errorTypes.FAIL, "Copy Failed"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // dispatch(loaders.social.pollLoader(false));
        setPollLoader(false);
      });
  };

export const lockPollHandler =
  (data, callback, setIsRefresh) => async (dispatch) => {
    dispatch(loaders.social.lockPollLoader(true));
    await apis.social
      .lockPoll(data)
      .then((response) => {
        if (response.data > 0) {
          setIsRefresh(true);
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Polls locked Successfully"),
          );
          callback();
        } else if (response.data === 0) {
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "You can't lock some of selected polls",
            ),
          );
          callback();
        } else if (response.data < 0)
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "Distributed polls cannot be locked",
            ),
          );
        else {
          dispatch(setErrorHandler(errorTypes.FAIL, "Lock Failed"));
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.social.lockPollLoader(false));
      });
  };
export const unlockPollHandler =
  (data, callback, setIsRefresh) => async (dispatch) => {
    dispatch(loaders.social.unlockPollLoader(true));
    await apis.social
      .unlockPoll(data)
      .then((response) => {
        if (response.data > 0) {
          setIsRefresh(true);
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Polls unlocked Successfully"),
          );
          callback();
        } else if (response.data === 0) {
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "You can't unlock some of selected polls",
            ),
          );
          callback();
        } else if (response.data < 0)
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "Distributed polls cannot be unlocked",
            ),
          );
        else {
          dispatch(setErrorHandler(errorTypes.FAIL, "Unlock Failed"));
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.social.unlockPollLoader(false));
      });
  };

export const pollResultHandler = (id, time, setData) => async () => {
  await apis.social
    .pollResult(id, time)
    .then((response) => {
      if (response.data) setData(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const pollResultByGroupIdHandler =
  (id, time, groupId, setData) => async () => {
    await apis.social
      .pollResultByGroupId(id, time, groupId)
      .then((response) => {
        if (response.data) setData(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getTenantPollUsersHandler =
  (isSearch, pollPreviewList) => async (dispatch) => {
    dispatch(loaders.social.distributePollLoader(true));
    await apis.social
      .getTenantPollUsers()
      .then((response) => {
        if (response.data) {
          const updatedData = response.data.map((item) => {
            if (isSearch) {
              if (
                pollPreviewList.some((user) => user?.LoginId === item?.LoginId)
              )
                return { ...item, isChecked: true };
              else return { ...item, isChecked: false };
            } else return { ...item, isChecked: false };
          });
          dispatch(setTenantPollUsers(updatedData));
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.social.distributePollLoader(false));
      });
  };

export const getPollUserGroupsSocialHandler =
  (isSearch, pollPreviewList) => async (dispatch) => {
    dispatch(loaders.social.distributePollLoader(true));
    await apis.social
      .getPollUserGroup()
      .then((response) => {
        if (response.data) {
          const updatedData = response.data.UserGroups.map((item) => {
            if (isSearch) {
              if (
                pollPreviewList.some(
                  (user) => user?.UserGroupId === item?.UserGroupId,
                )
              )
                return { ...item, isChecked: true };
              else return { ...item, isChecked: false };
            } else return { ...item, isChecked: false };
          });
          dispatch(setPollUserGroup(updatedData));
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.social.distributePollLoader(false));
      });
  };

export const getPollUserGroupsHandler = () => async (dispatch) => {
  dispatch(loaders.social.distributePollLoader(true));
  await apis.social
    .getPollUserGroup()
    .then((response) => {
      if (response.data) {
        const updatedData = response.data.UserGroups.map((item) => {
          return { ...item, isChecked: false };
        });
        dispatch(setPollUserGroup(updatedData));
      }
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.social.distributePollLoader(false));
    });
};

export const getSearchPollUserHandler =
  (SearchText, pollUsersData) => async (dispatch) => {
    dispatch(loaders.social.distributePollLoader(true));
    await apis.social
      .getSearchPollUser(SearchText)
      .then((response) => {
        if (response.data) {
          const updatedData = response?.data?.Users.map((item) => {
            if (pollUsersData.some((user) => user?.LoginId === item?.LoginId)) {
              return {
                ...item,
                isChecked: true,
              };
            } else {
              return {
                ...item,
                isChecked: false,
              };
            }
          });
          dispatch(setTenantPollUsers(updatedData));
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.social.distributePollLoader(false));
      });
  };

export const getSearchPollGroupHandler =
  (UserGroupId, pollUsersData) => async (dispatch) => {
    dispatch(loaders.social.distributePollLoader(true));
    await apis.social
      .getSearchPollGroup(UserGroupId)
      .then((response) => {
        if (response.data) {
          const updatedData = response?.data?.UserGroups.map((item) => {
            if (
              pollUsersData.some(
                (user) => user?.UserGroupId === item?.UserGroupId,
              )
            ) {
              return {
                ...item,
                isChecked: true,
              };
            } else {
              return {
                ...item,
                isChecked: false,
              };
            }
          });
          dispatch(setPollUserGroup(updatedData));
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.social.distributePollLoader(false));
      });
  };

export const distributePollHandler = (data) => async (dispatch) => {
  dispatch(loaders.social.pollLoader(true));
  await apis.social
    .distributePoll(data)
    .then((response) => {
      if (response.data) {
        dispatch(
          setErrorHandler(errorTypes.SUCCESS, "Poll Distributed Successfully"),
        );
        dispatch(distributePollResponse(response.data));
      } else {
        dispatch(setErrorHandler(errorTypes.FAIL, "Poll Distribution failed"));
      }
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      dispatch(loaders.social.pollLoader(false));
    });
};

/** POLL MANAGEMENT API HANDLER ENDS **/

/** FORUM AREA API HANDLER STARTS **/

export const getForumTopicsActionHandler =
  (pageNumber, pageSize, setForumTopicsData, setTotalRows, setTopicLoader) =>
  async (dispatch, getState) => {
    if (pageNumber === 1) setTopicLoader(true);
    await apis.social.forumArea
      .getForumTopics(pageNumber, pageSize)
      .then((response) => {
        if (pageNumber === 1) setTopicLoader(false);
        if (pageNumber > 1) {
          setForumTopicsData((prevState) =>
            prevState.concat(response.data.Content),
          );
          const prevState = getState().socialReducer?.forumTopics;
          dispatch(setForumTopics(prevState.concat(response.data.Content)));
        } else {
          setForumTopicsData(response.data.Content);
          dispatch(setForumTopics(response.data.Content));
        }
        setTotalRows(response.data.TotalRows);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getForumThreadsActionHandler =
  (
    topicId,
    pageNumber,
    pageSize,
    setForumThreadsData,
    setTotalRows,
    setThreadLoader,
  ) =>
  async (dispatch, getState) => {
    if (pageNumber === 1) setThreadLoader(true);
    await apis.social.forumArea
      .getForumThreads(topicId, pageNumber, pageSize)
      .then((response) => {
        if (pageNumber === 1) setThreadLoader(false);
        if (pageNumber > 1) {
          setForumThreadsData((prevState) =>
            prevState.concat(response.data.Content),
          );
          const prevState = getState().socialReducer?.forumThreads;
          dispatch(setForumThreads(prevState.concat(response.data.Content)));
        } else {
          setForumThreadsData(response.data.Content);
          dispatch(setForumThreads(response.data.Content));
        }
        setTotalRows(response.data.TotalRows);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getForumCommentsActionHandler =
  (
    threadId,
    pageNumber,
    pageSize,
    setForumCommentsData,
    setTotalRows,
    setForumCommentLoader,
  ) =>
  async () => {
    setForumCommentLoader(true);
    await apis.social.forumArea
      .getForumComments(threadId, pageNumber, pageSize)
      .then((response) => {
        setForumCommentLoader(false);
        if (pageNumber > 1) {
          setForumCommentsData((prevState) => {
            const reverseData = response.data.Content.reverse();
            return reverseData.concat(prevState);
          });
        } else {
          setForumCommentsData(response.data.Content.reverse());
        }
        setTotalRows(response.data.TotalRows);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const createForumTopicActionHandler =
  (data, setCreateForumTopicModal) => async (dispatch) => {
    const formData = new FormData();
    formData.append("file", data?.TopicThumbnailUrl);
    dispatch(loaders.social.forumArea.createForumTopicLoader(true));
    await apis.social
      .postImage(formData)
      .then((response) => {
        data.TopicThumbnailUrl = response.data;
        apis.social.forumArea
          .createForumTopic(data)
          .then((response) => {
            if (response.data) {
              setCreateForumTopicModal(false);
              dispatch(setCreateForumTopicResponse(response.data));
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  "Topic Created Successfully",
                ),
              );
            } else
              dispatch(
                setErrorHandler(errorTypes.FAIL, "Topic Creation Failed"),
              );
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.social.forumArea.createForumTopicLoader(false));
      });
  };

export const editForumTopicActionHandler =
  (data, setCreateForumTopicModal) => async (dispatch) => {
    if (
      isValidHttpUrl(data?.TopicThumbnailUrl) ||
      typeof data?.TopicThumbnailUrl === "string"
    ) {
      dispatch(loaders.social.forumArea.createForumTopicLoader(true));
      await apis.social.forumArea
        .editForumTopic(data)
        .then((response) => {
          if (response.data) {
            setCreateForumTopicModal(false);
            dispatch(setEditForumTopicResponse(response.data));
            dispatch(
              setErrorHandler(errorTypes.SUCCESS, "Topic Edited Successfully"),
            );
          } else
            dispatch(setErrorHandler(errorTypes.FAIL, "Topic Edit Failed"));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          dispatch(loaders.social.forumArea.createForumTopicLoader(false));
        });
    } else {
      const formData = new FormData();
      formData.append("file", data?.TopicThumbnailUrl);
      dispatch(loaders.social.forumArea.createForumTopicLoader(true));
      await apis.social
        .postImage(formData)
        .then((response) => {
          data.TopicThumbnailUrl = response.data;
          apis.social.forumArea
            .editForumTopic(data)
            .then((response) => {
              if (response.data) {
                setCreateForumTopicModal(false);
                dispatch(setEditForumTopicResponse(response.data));
                dispatch(
                  setErrorHandler(
                    errorTypes.SUCCESS,
                    "Topic Edited Successfully",
                  ),
                );
              } else
                dispatch(setErrorHandler(errorTypes.FAIL, "Topic Edit Failed"));
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          dispatch(loaders.social.forumArea.createForumTopicLoader(false));
        });
    }
  };

export const updateForumTopicActionHandler = (data) => async () => {
  await apis.social.forumArea
    .updateForumTopic(data)
    .then((response) => {
      if (response.data) {
        console.log(response.data);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const createForumThreadActionHandler =
  (data, setCreateForumThreadModal) => async (dispatch, getState) => {
    dispatch(loaders.social.forumArea.createForumThreadLoader(true));
    await apis.social.forumArea
      .createForumThread(data)
      .then((response) => {
        if (response.data) {
          setCreateForumThreadModal(false);
          dispatch(setCreateForumThreadResponse(response.data));
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Thread Created Successfully"),
          );
          const topicData = getState()?.socialReducer?.forumTopics;
          const updatedTopicData = topicData?.map((topic) => {
            if (topic?.Id === data?.TopicsId)
              return {
                ...topic,
                ForumThreadCount: topic?.ForumThreadCount + 1,
              };
            else return topic;
          });
          dispatch(setForumTopics(updatedTopicData));
        } else
          dispatch(setErrorHandler(errorTypes.FAIL, "Thread Creation Failed"));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() =>
        dispatch(loaders.social.forumArea.createForumThreadLoader(false)),
      );
  };

export const updateForumThreadActionHandler = (data) => async () => {
  await apis.social.forumArea
    .updateForumThread(data)
    .then((response) => {
      if (response.data) {
        console.log(response.data);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateDorumCommentActionHandler = (data) => async () => {
  return await apis.social.forumArea
    .updateDorumComment(data)
    .then((response) => {
      if (response) return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const createForumCommentActionHandler =
  (
    data,
    setData,
    setPageNum,
    selectedThreadId,
    forumCommentsPageNum,
    pageSize,
    setForumComments,
    setForumCommentsTotalRows,
  ) =>
  async (dispatch) => {
    dispatch(loaders.social.forumArea.createForumCommentLoader(true));
    await apis.social.forumArea
      .createForumComment(data)
      .then((response) => {
        if (response.data) {
          setData(response.data);
          setPageNum(1);
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Comment Created Successfully"),
          );
        } else
          dispatch(setErrorHandler(errorTypes.FAIL, "Comment Creation Failed"));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.social.forumArea.createForumCommentLoader(false));
        dispatch(
          getForumCommentsActionHandler(
            selectedThreadId,
            forumCommentsPageNum,
            pageSize,
            setForumComments,
            setForumCommentsTotalRows,
          ),
        );
      });
  };

/** FORUM AREA API HANDLER ENDS **/

/** MODERATE CONTRIBUTIONS API HANDLER STARTS **/

export const getSubmissionsDataActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setSbumissionsData,
    setTempSbumissionsData,
    setTotalRows,
  ) =>
  async () => {
    await apis.social.moderateContributions
      .getSubmissionsData(pageNumber, pageSize, searchText)
      .then((response) => {
        setSbumissionsData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTempSbumissionsData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTotalRows(response?.data?.TotalRows || 0);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getMyModerationDataActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setMyModerationData,
    setTempMyModerationData,
    setTotalRows,
  ) =>
  async () => {
    await apis.social.moderateContributions
      .getMyModerationData(pageNumber, pageSize, searchText)
      .then((response) => {
        setMyModerationData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTempMyModerationData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTotalRows(response?.data?.TotalRows || 0);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getLockedByOthersDataActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setLockedByOthersData,
    setTempLockedByOthersData,
    setTotalRows,
  ) =>
  async () => {
    await apis.social.moderateContributions
      .getLockByOthersData(pageNumber, pageSize, searchText)
      .then((response) => {
        setLockedByOthersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTempLockedByOthersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTotalRows(response?.data?.TotalRows || 0);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getRejectedDataActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setRejectedData,
    setTempRejectedData,
    setTotalRows,
  ) =>
  async () => {
    await apis.social.moderateContributions
      .getRejectedData(pageNumber, pageSize, searchText)
      .then((response) => {
        setRejectedData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTempRejectedData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTotalRows(response?.data?.TotalRows || 0);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getPublishedDataActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setPublishedData,
    setTempPublishedData,
    setTotalRows,
  ) =>
  async () => {
    await apis.social.moderateContributions
      .getPublishedData(pageNumber, pageSize, searchText)
      .then((response) => {
        setPublishedData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTempPublishedData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTotalRows(response?.data?.TotalRows || 0);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getPublishedByOthersDataActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setPublishedByOthersData,
    setTempPublishedByOthersData,
    setTotalRows,
  ) =>
  async () => {
    await apis.social.moderateContributions
      .getPublishedByOthersData(pageNumber, pageSize, searchText)
      .then((response) => {
        setPublishedByOthersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTempPublishedByOthersData((prevStateData) => [
          ...prevStateData,
          ...response?.data?.Content,
        ]);
        setTotalRows(response?.data?.TotalRows || 0);
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getShotclassSourcingClassDetailsByIdActionHandler =
  (shotclassId, status) => async (dispatch) => {
    dispatch(loaders.common.pageLoader(true));
    await apis.social.moderateContributions
      .getShotclassSourcingClassDetailsById(shotclassId, status)
      .then((response) => {
        if (response?.data) {
          dispatch(getClassDetailsByIdAction(response?.data));
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.common.pageLoader(false));
      });
  };

export const getModeratorContributorCommentsActionHandler =
  (shotclassId, setData) => async (dispatch) => {
    // dispatch(loaders.common.pageLoader(true));
    await apis.social.moderateContributions
      .getModeratorContributorComments(shotclassId)
      .then((response) => {
        if (response?.data) {
          dispatch(getClassDetailsByIdAction(response?.data));
          setData(response?.data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // dispatch(loaders.common.pageLoader(false));
      });
  };

export const postContributorModeratorCommentsActionHandler =
  (classId, comments, isContributor, setData) => async (dispatch) => {
    // dispatch(loaders.common.pageLoader(true));
    await apis.social.moderateContributions
      .postContributorModeratorComments(classId, comments, isContributor)
      .then((response) => {
        if (response?.data) {
          setData(response?.data);
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Comment Created Successfully"),
          );
        } else
          dispatch(setErrorHandler(errorTypes.FAIL, "Comment Creation Failed"));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // dispatch(loaders.common.pageLoader(false));
      });
  };

export const lockContributorShotClassActionHandler =
  (classId) => async (dispatch) => {
    // dispatch(loaders.common.pageLoader(true));
    await apis.social.moderateContributions
      .lockContributorShotClass(classId)
      .then((response) => {
        if (response) {
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Content Locked Successfully"),
          );
        } else
          dispatch(setErrorHandler(errorTypes.FAIL, "Content Lock Failed"));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // dispatch(loaders.common.pageLoader(false));
      });
  };

export const unLockContributorShotClassActionHandler =
  (classId, navigate, location, handleSearchQuery, tenantName) =>
  async (dispatch) => {
    // dispatch(loaders.common.pageLoader(true));
    await apis.social.moderateContributions
      .unLockContributorShotClass(classId)
      .then((response) => {
        if (response) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              "Content UnLocked Successfully",
            ),
          );
          if (location?.pathname === myModerations.path(tenantName))
            handleSearchQuery();
          else navigate(submisssions.path(tenantName));
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // dispatch(loaders.common.pageLoader(false));
      });
  };

export const rejectShotClassActionHandler =
  (classId, navigate, tenantName) => async (dispatch) => {
    // dispatch(loaders.common.pageLoader(true));
    await apis.social.moderateContributions
      .rejectShotClass(classId)
      .then((response) => {
        if (response) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              "Content Rejected Successfully",
            ),
          );
          navigate(submisssions.path(tenantName));
        } else
          dispatch(
            setErrorHandler(errorTypes.FAIL, "Content Rejection Failed"),
          );
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // dispatch(loaders.common.pageLoader(false));
      });
  };

export const updateShotClassSourcingActionHandler =
  (shotclassData, navigate, tenantName) => async (dispatch) => {
    let mediaType = shotclassData.details.Content.ContentMediaType;
    let isContent = !!shotclassData.details.Content.ContentValue;
    let quizQuestionList = shotclassData.addQuiz.QuestionsList.map(
      (question) => {
        let {
          Question,
          QuestionImage,
          Explanation,
          ActiveQuestionType,
          IsCorrect,
          AnswersList,
          ...restQuestion
        } = question;
        return {
          ...restQuestion,
          // AssessmentName: null,
          // ID: shotclassData.ID,
          Type: ActiveQuestionType,
          Text: Question,
          // PositiveMark: 1,
          // NegativeMark: 0,
          ChoiceList:
            ActiveQuestionType === 1
              ? AnswersList?.map((answer, index) => {
                  let { Answer, AnswerImage, ...restAnswer } = answer;

                  return {
                    ...restAnswer,
                    // ID: shotclassData.ID,
                    Text: Answer,
                    IsAnswer: parseInt(IsCorrect) === index,
                    // ImageForWorng: answer?.ImageForWorng || "",
                    // ImageForCorrect: answer?.ImageForCorrect || "",
                    // Isselected: answer?.Isselected || "",
                    // IsselectedByUserInResonse:
                    //   answer?.IsselectedByUserInResonse || false,
                    // IsDeleted: answer?.IsDeleted || false,
                    // QuestionId: answer?.QuestionId,
                    // BaseChoiceId: answer?.BaseChoiceId,
                    // VaraintChoiceId: answer?.VaraintChoiceId,
                    ChoiceImageList: AnswerImage?.MediaUri
                      ? {
                          MediaUri: AnswerImage?.MediaUri,
                          FileName: AnswerImage?.FileName,
                          Mediaid: AnswerImage?.Mediaid,
                          FileType: AnswerImage?.FileType,
                          FileSizeinKB: AnswerImage?.FileSizeinKB,
                          Base64: "",
                          ThumbnailUri: AnswerImage?.ThumbnailUri,
                          LabelValue: "",
                        }
                      : null,
                    // ChoiceAudioList: null,
                    // ChoiceVideoList: null,
                  };
                })
              : AnswersList.length > 1
                ? AnswersList.map((answer) => {
                    let { Answer, AnswerImage, ...restAnswer } = answer;
                    if (answer?.Text === "True") {
                      return {
                        ...restAnswer,
                        Text: "True",
                        IsAnswer: IsCorrect === "0",
                        keyText: "TRUE_TEXT",
                      };
                    } else {
                      return {
                        ...restAnswer,
                        Text: "False",
                        IsAnswer: IsCorrect === "1",
                        keyText: "FALSE_TEXT",
                      };
                    }
                  })
                : [
                    {
                      Text: "True",
                      IsAnswer: IsCorrect === "0",
                      keyText: "TRUE_TEXT",
                    },
                    {
                      Text: "False",
                      IsAnswer: IsCorrect === "1",
                      keyText: "FALSE_TEXT",
                    },
                  ],
          // IsDeleted: question?.IsDeleted,
          Explaination: Explanation,
          // AnswerHint: question?.AnswerHint,
          QuestionImageList: QuestionImage?.MediaUri
            ? [
                {
                  MediaUri: QuestionImage?.MediaUri,
                  FileName: QuestionImage?.FileName,
                  Mediaid: QuestionImage?.Mediaid,
                  FileType: QuestionImage?.FileType,
                  FileSizeinKB: QuestionImage?.FileSizeinKB,
                  Base64: "",
                  ThumbnailUri: QuestionImage?.ThumbnailUri,
                  LabelValue: "",
                  isSelected: true,
                },
              ]
            : [],
          // QuestionAudioList: question?.QuestionAudioList,
          // QuestionVideoList: question?.QuestionVideoList,
          // Duration: question?.Duration,
          // QuestionNo: question?.QuestionNo,
          // BaseQuestionId: question?.BaseQuestionId,
          // VariantQuestionId: question?.VariantQuestionId,
          // QuizTemplateId:question?.QuizTemplateId,
        };
      },
    );
    let surveyQuestionList = shotclassData.addSurvey.QuestionsList.map(
      (question) => {
        let {
          Question,
          ActiveQuestionType,
          AnswersList,
          MultiSelect,
          IsFreeFormTextBox,
          ...restQuestion
        } = question;
        return {
          ...restQuestion,
          Choices: IsFreeFormTextBox
            ? [{ Text: "" }, { Text: "" }, { Text: "" }, { Text: "" }]
            : ActiveQuestionType === 1
              ? AnswersList?.map((answer) => {
                  let { Answer, ...restAnswer } = answer;
                  return { ...restAnswer, Text: Answer };
                })
              : ActiveQuestionType === 2
                ? AnswersList?.length > 1
                  ? AnswersList?.map((answer) => {
                      let { Answer, ...restAnswer } = answer;
                      if (answer?.Text === "True") {
                        return {
                          ...restAnswer,
                          Text: "True",
                          keyText: "TRUE_TEXT",
                        };
                      } else {
                        return {
                          ...restAnswer,
                          Text: "False",
                          keyText: "FALSE_TEXT",
                        };
                      }
                    })
                  : [
                      { Text: "True", keyText: "TRUE_TEXT" },
                      { Text: "False", keyText: "FALSE_TEXT" },
                    ]
                : [{ Text: "" }, { Text: "" }, { Text: "" }, { Text: "" }],
          // Edit: false,
          // ErrorMessages: [],
          // Id: 0,
          // Index: 0,
          IsFreeFormText: IsFreeFormTextBox,
          // Mode: 1,
          MultiSelect: MultiSelect,
          QuestionType: IsFreeFormTextBox
            ? 3
            : ActiveQuestionType === 1
              ? MultiSelect
                ? 4
                : 1
              : ActiveQuestionType === 2
                ? 2
                : 0,
          Text: Question,
        };
      },
    );
    let data = {
      ...shotclassData?.Other,
      // ID: shotclassData.ID,
      ParentId: shotclassData.ShotclassId?.toString(),
      // .toString(),
      Name: shotclassData.details.ShotClassName,
      ImageUrl:
        typeof shotclassData.details.ThumbnailImage === "string"
          ? shotclassData?.details?.ThumbnailImage
          : shotclassData?.details?.ThumbnailImage?.MediaUri,
      // ImageFileSizeinKB: null,
      Description: shotclassData.details.Summary,
      KeyLearning: shotclassData.details.Description,
      VideoUrl:
        // mediaType === 2 || mediaType === 8
        //   ?
        shotclassData.details.Content.ContentMediaExtension === ""
          ? shotclassData.details.Content.ContentValue
          : shotclassData.details.Content.ContentValue[0]?.link,
      // : ""
      VideoDuration:
        mediaType === 2
          ? shotclassData.details.Content.ContentValue[0].Duration
          : null,
      VideoThumbnailUrl:
        typeof shotclassData.details.ThumbnailImage === "string"
          ? shotclassData?.details?.ThumbnailImage
          : shotclassData?.details?.ThumbnailImage?.MediaUri,
      AssessmentSet: {
        ...shotclassData?.Other?.AssessmentSet,
        ParentId: shotclassData?.Other?.AssessmentSet.ID,
        Name: shotclassData.details.ShotClassName,
        // Description: "",
        // Duration: 1,
        // MaxScore: 100,
        MinScore:
          shotclassData.addQuiz.TotalQuestionCount > 0
            ? shotclassData.addQuiz.PassingMarks
              ? parseInt(shotclassData.addQuiz.PassingMarks)
              : ""
            : 0,
        // AllowReattempt: false,
        QuestionList:
          shotclassData.addQuiz.TotalQuestionCount > 0 ? quizQuestionList : [],
        // Locale: shotclassData.details.Language,
        // ParentId: 0,
        // ID: shotclassData.ID,
      },
      // Credits: "",
      Tags: shotclassData.details.TagsList.map((tag) => tag.TagName).join(","),
      Status: "Under_Review",
      // VideoUploadStatus: "VideoNotAvailable",
      // Logo: "https://mlearn.blob.core.windows.net/shotclass/img/hp-logo.gif",
      // CategoryID: "",
      TrainingTypeId: shotclassData.details.TrainingType?.map(
        (training) => training.TypeId,
      ),
      // Type: "ShotClass",
      // ParentId: 0,
      Mediatype: mediaType,
      // MediaSource: "",
      // MoocCourseSubType: 0,
      // Locale: shotclassData.details.Language,
      IsMediaDownloadable: shotclassData.publish.OfflineShotclass,
      IsClassDownloadable: shotclassData.publish.OfflineShotclass,
      IsRestrictedClass: shotclassData.publish.HasRestricted,
      IsVideoMandatory: shotclassData.publish.IsVideoMandatory,
      IsRandomQuestionAllowed: shotclassData.publish.QuestionJumbling,
      ShowCorrectAnswer: shotclassData.publish.ShowCorrectAnswers,
      LearnerChangeAnswerOptions: shotclassData.publish.CanChangeAnswers,
      ShotclassTargetGroupMapping: shotclassData.publish.TagsList?.map(
        (tag) => {
          return { TargetGroupId: 1, TargetGroupMemberId: tag.TagValue };
        },
      ),
      Survey:
        shotclassData.addSurvey.TotalQuestionCount > 0
          ? {
              ...shotclassData?.Other?.Survey,
              // SurveyId: "",
              // Locale: shotclassData.details.Language,
              // ShotClassId: shotclassData.ID,
              IsMandatory: shotclassData.publish.IsSurveyMandatory,
              Questions:
                shotclassData.addSurvey.TotalQuestionCount > 0
                  ? surveyQuestionList
                  : [],
            }
          : null,
      ShotClassType: shotclassData.publish.LearningContentOnly,
    };
    return await apis.social.moderateContributions
      .updateShotClassSourcing(data)
      .then((response) => {
        if (response?.data) {
          const classId = response?.data?.split(":")[1]?.trim();
          const shotclassName = shotclassData?.details?.ShotClassName;
          const fileData = shotclassData.details.Content.ContentValue[0];
          const fileName = fileData?.name;
          const fileSize = fileData?.size;
          const fileExtension =
            shotclassData.details.Content.ContentMediaExtension;
          if ((fileData && fileExtension) || mediaType === 5) {
            if (mediaType === 1) {
              const blockLength = 1048576;
              const blockCount = Math.ceil(fileSize / blockLength);

              dispatch(getStoredMediaInfoActionHandler(classId))
                .then(() => {
                  return dispatch(
                    setMetaDataForVideoActionHandler(
                      blockCount,
                      fileName,
                      fileSize,
                      shotclassName,
                    ),
                  );
                })
                .then((data) => {
                  let uploadChunkObject = {
                    videoGuid: data?.VideoGuid,
                    classId: classId,
                    isVariant: false,
                    status: "Published",
                    fileName: fileName,
                    url: "uploading",
                    fileSize: fileSize,
                    blockLength: blockLength,
                    blockCount: blockCount,
                    uploadStatusMessage: "xsadsd",
                    isUploadCompleted: false,
                    isShotClassSourcingFromLearner: false,
                    file: fileData,
                  };
                  dispatch(uploadVideoChunkActionHandler(uploadChunkObject));
                });
            } else if (mediaType === 3) {
              return dispatch(
                uploadPptShotClassActionHandler(
                  classId,
                  fileExtension,
                  false,
                  "Published",
                  fileData,
                ),
              );
            } else if (mediaType === 5) {
              dispatch(
                uploadSlideShareActionHandler(classId, "Published", fileData),
              );
            } else if (mediaType === 7) {
              return dispatch(
                uploadPdfShotClassActionHandler(
                  classId,
                  fileExtension,
                  false,
                  "Published",
                  fileData,
                ),
              );
            } else if (mediaType === 9 || mediaType === 11) {
              let isHTML = mediaType === 11 ? true : false;
              return dispatch(
                uploadScormOrHtmlShotClassActionHandler(
                  isHTML,
                  classId,
                  fileExtension,
                  fileName,
                  false,
                  "Published",
                  fileData,
                ),
              );
            }
          } else {
            return true;
          }
          // navigate(submisssions.path(tenantName));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const isShortclassNameExistsActionHandler =
  (searchText) => async (dispatch) => {
    return await apis.manage
      .isNameExists(searchText)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };

/** MODERATE CONTRIBUTIONS API HANDLER ENDS **/

export const pollDownloadResultActionHandler = (url) => async () => {
  await apis.social
    .pollDownloadResult(url)
    .then((response) => {
      const binaryData = response.data;
      const file = new Blob([binaryData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const fileName = `Poll Result Download_${moment().format(
        "DMMMYYYY_hhmmss",
      )}`;
      const url = window.URL.createObjectURL(file);
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = fileName + ".xlsx";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      return file;
    })
    .catch((err) => {
      console.log(err);
    });
};
